"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Modules;
(function (Modules) {
    Modules["Agitator"] = "Agitator";
    Modules["Medic"] = "Medic";
    Modules["Mother"] = "Mother";
    Modules["Move"] = "Move";
    Modules["Officer"] = "Officer";
    Modules["Saboteur"] = "Saboteur";
    Modules["Scout"] = "Scout";
})(Modules = exports.Modules || (exports.Modules = {}));
var Foundations;
(function (Foundations) {
    Foundations["Mine"] = "Mine";
})(Foundations = exports.Foundations || (exports.Foundations = {}));
var Armies;
(function (Armies) {
    Armies["Smart"] = "Smart";
    Armies["Vegas"] = "Vegas";
})(Armies = exports.Armies || (exports.Armies = {}));
